import { AppState } from '../app.reducer';

export const correlationIdSelector = (state: AppState) => state.correlationId;
